<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
        <div class="col-sm-12 p-0">
            <div class="col-sm-6">
                <h2 *ngIf="!isHisto" style="width: 95%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                    CAP du client </h2>
                <h2 *ngIf="isHisto"> Historique des CAP </h2>

            </div>
            <div class="col-sm-6 text-right">
                <button class="btn-header uppercase" id="close" (click)="exportXLS()"> Extraire XLS </button>
                <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
            </div>
        </div>
        <div class="col-sm-12">
            <h2 *ngIf="!isHisto" class="col-sm-12 p-0"
                style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"> {{detail.nomClient || ''}} </h2>
            <div class="text-underline historique" style="padding-right: 0px" (click)="showHisto()">
                <span *ngIf="!isHisto"> Afficher l'historique </span>
                <span *ngIf="isHisto"> Afficher la liste </span>
            </div>
        </div>

    </div>

    <div class="col-sm-12 ligneBon liste" [ngStyle]="{'height': !isHisto ? 'calc(100% - 155px)' : 'calc(100% - 130px)'}">
        <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listCAP || []"
            [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
            [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
            [selected]="selected">

            <ngx-datatable-column prop="exutoire.nom">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Exutoire </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.exutoire ? (value || row.exutoire.libelleObjetEntite) : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="article.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Article </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.article ? (value || row.article.libelleObjetEntite) : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="numCAP">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> N° CAP </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="dateValidite">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Date de validité </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span> {{value}} </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="chantier.numChantier">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Chantier ciblé </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.chantier">
                        {{value}} {{row.chantier ? (row.chantier.responsable ? '/ ' +row.chantier.responsable : '') :
                        ''}}
                        {{row.chantier ? (row.chantier.adresse1 ? ' / ' + row.chantier.adresse1 : '') : ''}}
                        {{row.chantier ? (row.chantier.ville ? '/ ' + row.chantier.ville : '') : ''}}
                    </span>
                    <span *ngIf="!row.chantier">
                        Tous
                    </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="contenant.libelleObjetEntite">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Contenant </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.contenant ? value : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="exutoireUlterieur.nom">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Exutoire ultérieur </span>
                        <div class=" shorticone pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.exutoireUlterieur ? (value || row.exutoireUlterieur.libelleObjetEntite) : 'Par défaut'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                [resizeable]="false">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                        <button class="btn-detail" (click)="showFormEdit(row);">
                            <i class="fa fa-pencil"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
        <div class="col-sm-7 text-left">
            <!--button class="btn-add" id="addLigne" (click)="selectedRow = {}; common.openModal(modalService, formEdit)">
              <i class="fa fa-plus"></i>
            </button>
            <span (click)="selectedRow = {}; common.openModal(modalService, formEdit)">Ajouter une ligne</span-->
            <button class="btn-add" id="addLigne" (click)="showFormEdit({})">
                <i class="fa fa-plus"></i>
            </button>
            <span (click)="showFormEdit({})">Ajouter une ligne</span>

        </div>
        <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit
    (click)="common.outSide($event)">
    <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
        <h4 class="modal-title pull-left col-sm-8"> {{selectedRow.id ? 'Modifier un CAP' : 'Ajout d\'un CAP'}} </h4>
        <div class="col-sm-4 text-right">
            <button type="button" class="btn-header uppercase" (click)="selectedRow = {};isEdit = false;"> Fermer
            </button>
            <button type="button" class="btn-header uppercase actionPricipal" (click)="validerFormEdit();">
                Valider </button>
        </div>
    </div>
    <div class="modalFicheClient col-sm-12">
        <div class="col-sm-12">
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Article :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.checkOperation}">
                    <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                        (selectfunction)="selectedRow.article = $event;" [notOblig]="true" [label]="''"
                        [defaultselected]="selectedRow.article" [selectvalue]="true" [results]="dataArticle"
                        [id]="'modedepaie article'"
                        [defaultsearch]="selectedRow.article ? (selectedRow.article.libelle || selectedRow.article.libelleObjetEntite) : ''"
                        [autohide]="true" [dropdownclass]="'dropDownPrixNego'"
                        (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="!isFamille2">
                <label class="col-sm-3 champ" style="padding:0px">
                    Date de validité :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-input-date [class]="'form-control'" [id]="'date'" [model]="selectedRow.modelDebut"
                        (changefct)="selectedRow.modelDebut = $event; changeDate($event, selectedRow);"
                        [placeholder]="'Date de validité'"
                        (keyenterfct)="common.changeDate($event, selectedRow.modelDebut, '#date');"
                        (selectfct)="selectDate($event, '#date');" [showDatepicker]="true"></app-input-date>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Exutoire ciblé:
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
                        [id]="'modedepaie exutoire'" (selectfunction)="selectedRow.exutoire = $event"
                        [results]="listExutoire" [showonclick]="true" [label]="''"
                        [defaultselected]="selectedRow.exutoire"
                        [defaultsearch]="selectedRow.exutoire ? (selectedRow.exutoire.libelleObjetEntite || selectedRow.exutoire.nom) : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    N° CAP :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" [(ngModel)]="selectedRow.numCAP" autocomplete="off"
                        (keydown.enter)="common.focusNext('.modalFicheClient')">
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Chantier ciblé :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
                    <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
                        (selectfunction)="selectedRow.chantier = $event;" [results]="listChantier" [showonclick]="true"
                        [defaultselected]="selectedRow.chantier" [label]="''" id="modedepaie autoCht"
                        [defaultsearch]="selectedRow.chantier ? (selectedRow.chantier.numChantier || selectedRow.chantier.responsable || selectedRow.chantier.libelleObjetEntite) : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Contenant :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete (selectfunction)="selectedRow.contenant = $event;" [isCombo]="true"
                        [results]="typeContenant" [highlight]="true" [label]="''" id="modedepaie typecontenants"
                        [selectvalue]="true" [placeholder]="'Type contenant'" [defaultselected]="selectedRow.contenant"
                        [defaultsearch]="selectedRow.contenant ? selectedRow.contenant.libelleObjetEntite : 'Tous'"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Exutoire ultérieur:
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoireUlt($event)"
                        [id]="'modedepaie exutoire'" (selectfunction)="selectedRow.exutoireUlterieur = $event"
                        [results]="listExutoireUlterieur" [label]="''" [defaultselected]="selectedRow.exutoireUlterieur"
                        [defaultsearch]="selectedRow.exutoireUlterieur ? (selectedRow.exutoireUlterieur.libelleObjetEntite || selectedRow.exutoireUlterieur.nom) : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>